import { render, staticRenderFns } from "./pick-up-info.component.vue?vue&type=template&id=462b4414"
import script from "./pick-up-info.component.ts?vue&type=script&lang=ts&external"
export * from "./pick-up-info.component.ts?vue&type=script&lang=ts&external"
import style0 from "./pick-up-info.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports